import React, { Component } from 'react';
import { source } from 'react-aim';

import { dispatch } from '@rematch/core';

import HomeResourcePane from "../ResourcesPane/home";
import InvitedUsersResourcePane from '../ResourcesPane/InvitedUsers';
import UsersResourcePane from '../ResourcesPane/Users';
import ActiveInitiativeProgress from '../../Initiatives/ResourcesPane/ActiveInitiativeProgress'

import '@zippytech/react-toolkit/Accordion/index.css';
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class IndexResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = {
            transactionTime: 300,
            transitioinFunction: 'linear'
        }
    }

    componentWillUnmount() {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.organizationUnit.setActivePaneIndex(null)
    }


    render() {
        return (
            this.props.showResourecePaneFlag === "Home" ?
                <HomeResourcePane {...this.props} transactionTime={this.state.transactionTime} transitionFunction={this.state.transitioinFunction} />
                : this.props.showResourecePaneFlag === "Invited" ?
                    <InvitedUsersResourcePane {...this.props} inviteUserList={this.props.inviteUserList}
                        user={this.props.user} transactionTime={this.state.transactionTime} />
                    : this.props.showResourecePaneFlag === "User" ?
                        <UsersResourcePane userObj={this.props.userObj} organizationId={this.props.selectedOrganisation.id} {...this.props} transactionTime={this.state.transactionTime} />
                        : this.props.showResourecePaneFlag === "ActiveProgress" ?
                            <ActiveInitiativeProgress {...this.props} />
                            : ""
        )
    }
}

export default IndexResourcePane;